/**
 * df-search-preview.js — l'aperçu de recherche montre les MÊMES produits, dans le MÊME
 * ordre, que la page de résultats.
 *
 * POURQUOI. Deux moteurs servaient la même frappe (bug 2026-11-03, « soft touch ») :
 *   - l'aperçu du header (composant vendor <predictive-search>, theme.js) interroge
 *     /search/suggest = l'API prédictive de Shopify, avec la requête BRUTE ;
 *   - la validation passe par df-search.js qui RÉÉCRIT la requête (filtres modèle/type,
 *     ou syntaxe `title:`/`body:` dès 2 mots libres) avant d'ouvrir /search.
 *   Mesuré : aperçu Noir, Marine, Beige, Marron — page Violet, Framboise, Noir, Marron.
 *   Même sans réécriture, /search classe autrement que /search/suggest (Beige d'abord).
 *
 * COMMENT. On garde l'aperçu natif (suggestions de requêtes, onglet Collections) et on
 * remplace seulement ses vignettes produits par celles de la page de résultats : même
 * URL que df-search.js ouvrira à la validation (LCFSearch.build), rendue par la section
 * `predictive-search` (branche `search.performed`, mêmes vignettes). L'échelle de repli
 * de la page (0 résultat -> cran suivant) est rejouée à l'identique.
 * Les vignettes natives sont masquées dès leur insertion (MutationObserver = avant le
 * premier rendu) jusqu'à l'échange : aucun clignotement d'un ordre à l'autre.
 *
 * Hors champ : une requête qui n'est qu'un modèle (« iphone 13 ») ouvre la COLLECTION du
 * modèle, pas une recherche — l'aperçu natif reste tel quel.
 * B2C seulement : df-search.js (partagé avec le B2B) n'est pas modifié.
 */
(function () {
  'use strict';

  if (!window.LCFSearch || !window.LCFSearch.build) return;
  var LCF = window.LCFSearch;
  var NEXT = { A1: 'A2', B1: 'B2', B2: 'B3' };   // même échelle que df-search.js
  var cache = new Map();                          // requête brute -> Promise<Element[] | null>

  function tilesOf(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var box = doc.querySelector('.predictive-search__products');
    return box ? Array.prototype.slice.call(box.children) : [];
  }

  /* Les vignettes que la page de résultats affichera, cran par cran comme elle. */
  function resultTiles(raw, rung) {
    var plan = LCF.build(raw, rung);
    if (plan.mode === 'collection') return Promise.resolve(null);
    var url = plan.url + (plan.url.indexOf('?') < 0 ? '?' : '&') + 'section_id=predictive-search';
    return fetch(url).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.text();
    }).then(function (html) {
      var tiles = tilesOf(html);
      var next = NEXT[plan.rung];
      return tiles.length || !next ? tiles : resultTiles(raw, next);
    });
  }

  function tilesFor(raw) {
    if (!cache.has(raw)) {
      if (cache.size > 20) cache.delete(cache.keys().next().value);
      cache.set(raw, resultTiles(raw).catch(function (e) {
        cache.delete(raw);
        console.warn('[df-search-preview] aperçu natif conservé :', e);
        return null;
      }));
    }
    return cache.get(raw);
  }

  function inputOf(ps) {
    var form = document.querySelector('[aria-owns="' + ps.id + '"]');
    return form && form.elements.q;
  }

  /* Le composant vendor annonce sa requête (après son propre délai de frappe) :
     on part en même temps que lui, la réponse est souvent là avant la sienne. */
  document.documentElement.addEventListener('theme:loading:start', function () {
    Array.prototype.forEach.call(document.querySelectorAll('predictive-search[id]'), function (ps) {
      var input = inputOf(ps);
      var raw = input && input.value.trim();
      if (raw) tilesFor(raw);
    });
  });

  function swap(ps, box) {
    var input = inputOf(ps);
    var raw = input && input.value.trim();
    if (!raw) return;
    var n = box.children.length;
    box.style.visibility = 'hidden';
    tilesFor(raw).then(function (tiles) {
      if (!box.isConnected || input.value.trim() !== raw) return;   // une frappe plus récente gagne
      if (tiles && tiles.length) box.replaceChildren.apply(box, tiles.slice(0, n).map(function (t) {
        return document.importNode(t, true);
      }));
      box.style.visibility = '';
    });
  }

  function watch(ps) {
    var slot = ps.querySelector('[slot="results"]');
    if (!slot) return;
    new MutationObserver(function () {
      var box = slot.querySelector('.predictive-search__products');
      if (box) swap(ps, box);
    }).observe(slot, { childList: true });
  }

  Array.prototype.forEach.call(document.querySelectorAll('predictive-search[id]'), watch);
})();
